import styled from 'styled-components';

import { theme } from '../../../global-styles/colors';

interface IModalContainerStyle {
  height: number;
}

export const ModalContainerStyle = styled.div<IModalContainerStyle>`
  z-index: 1200;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s ease-in-out all;

  .modal-wrapper {
    max-width: 476px;
    margin: 0 auto;
    position: relative;
    display: flex;
    align-items: flex-end;
    overflow: hidden;
  }
  .modal-container {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .modal-veil {
    background: ${theme.overlay.dark};
    width: 100%;
    position: fixed;
    opacity: 0;
    transition: 0.3s ease-in-out all;
    left: 0;
    top: 0;
    height: ${(props) => (props.height ? `${props.height}px` : '100vh')};
  }

  .modal-children {
    margin-bottom: 32px;
    position: relative;
    /* z-index: 9999999; */
  }

  .modal-content {
    padding: 28px 16px;
    background: ${theme.neutrals.white};
    transform: translateY(100%);
    position: sticky;
    bottom: 0;
    transition: 0.3s ease-out all;
    z-index: 2;
    border-radius: 12px 12px 0 0;
    margin: 0 auto;
    max-width: 520px;
    overflow-y: auto;
  }

  .modal-navbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 64px;
    background: white;
    width: 100%;
    padding: 16px 0;
    z-index: 1;
  }
  .modal-content-line-wrapper {
    left: 0;
    width: 100%;
    top: 0;
    margin: 0 auto;
    position: absolute;
    padding: 8px;
    cursor: pointer;
    display: flex;
    justify-content: center;
  }
  .modal-content-line {
    width: 40px;
    height: 4px;
    background: #dfe2e4;
    border-radius: 1px;
  }

  .modal-top {
    margin-bottom: 32px;
  }
  .modal-text {
    margin-top: 16px;
  }
  .modal-buttons {
    z-index: 1189;
    &__item {
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }

  &.active {
    opacity: 1;
    visibility: visible;
    .modal-veil {
      opacity: 1;
    }
    .modal-content {
      transform: translateY(0%);
    }

    &.full-screen {
      .modal-content {
        transform: translateX(0%) translateY(-100%);
        width: 100%;
      }
    }
  }

  &.full-screen {
    &.buttons-relative {
      .modal-buttons {
        position: relative;
        bottom: 0;
      }
    }
    .modal-buttons {
      position: sticky;
      bottom: 0;
    }
    .modal-veil {
      background: none;
    }
    .modal-content {
      padding: 0px 16px 28px;
      transform: translateX(100%) translateY(-100%);
      position: absolute;
      top: 0;
      left: 0;
      height: ${(props) => (props.height ? `${props.height}px` : '100vh')};
      transition: 0.3s ease-out all;
      z-index: 2;
      border-radius: 0;
      overflow-y: auto;
    }
  }
`;
